import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Инициализация анимации для мобильных устройств
export const initServicesAnimation = () => {
    // Проверяем, что мы на мобильном устройстве (ширина меньше 1024px)
    const isMobile = window.innerWidth < 1024;
    
    if (!isMobile) return;

    // Получаем слайдер и все карточки
    const servicesSlider = document.querySelector('.services-slider');
    // Выбираем только слайды Swiper (не вложенные элементы с тем же классом)
    const serviceSlides = document.querySelectorAll('.services-slider .swiper-slide.services-slider-slide');
    
    if (!servicesSlider || serviceSlides.length === 0) return;

    // Убиваем существующие ScrollTriggers для services чтобы избежать дубликатов
    const existingMobilePin = ScrollTrigger.getById('services-mobile-pin');
    if (existingMobilePin) {
        existingMobilePin.kill();
    }
    
    const existingDesktopPin = ScrollTrigger.getById('services-desktop-pin');
    if (existingDesktopPin) {
        existingDesktopPin.kill();
    }

    const totalSlides = serviceSlides.length;

    // Устанавливаем начальное положение для всех карточек
    serviceSlides.forEach((slide, index) => {
        const container = slide.querySelector('.container');
        if (!container) return;
        
        const image = container.querySelector('.services-slider-slide-image');
        const title = container.querySelector('.services-slider-slide-title');
        const description = container.querySelector('.services-slider-slide-description');
        const lists = container.querySelectorAll('.popup-right-content-list');
        
        if (index === 0) {
            gsap.set(container, { x: 0, scale: 1, autoAlpha: 1 });
        } else {
            gsap.set(container, { x: '100%', scale: 0.98, autoAlpha: 1 });
            
            if (image) gsap.set(image, { x: 60, scale: 0.9 });
            if (title) gsap.set(title, { x: 50, opacity: 0 });
            if (description) gsap.set(description, { x: 40, opacity: 0 });
            if (lists.length) gsap.set(lists, { x: 30, opacity: 0 });
        }
    });

    // Анимация первой карточки при появлении на экране
    const firstSlide = serviceSlides[0];
    if (firstSlide) {
        const container = firstSlide.querySelector('.container');
        const image = container?.querySelector('.services-slider-slide-image');
        const title = container?.querySelector('.services-slider-slide-title');
        const description = container?.querySelector('.services-slider-slide-description');
        const lists = container?.querySelectorAll('.popup-right-content-list');

        if (image) gsap.set(image, { x: 60, scale: 0.9 });
        if (title) gsap.set(title, { x: 50, opacity: 0 });
        if (description) gsap.set(description, { x: 40, opacity: 0 });
        if (lists) gsap.set(lists, { x: 30, opacity: 0 });

        gsap.timeline({
            scrollTrigger: {
                trigger: servicesSlider,
                start: 'top 80%',
                toggleActions: 'play none none reverse'
            }
        })
        .to(image, { x: 0, scale: 1, ease: 'back.out(1.4)', duration: 0.8 }, 0)
        .to(title, { x: 0, opacity: 1, ease: 'power3.out', duration: 0.6 }, 0.15)
        .to(description, { x: 0, opacity: 1, ease: 'power3.out', duration: 0.6 }, 0.25)
        .to(lists, { x: 0, opacity: 1, ease: 'power3.out', duration: 0.6, stagger: 0.08 }, 0.35);
    }

    // Создаем мастер timeline для всех слайдов
    const masterTimeline = gsap.timeline({ paused: true });
    
    // Добавляем анимации для каждого слайда (начиная со второго)
    for (let index = 1; index < totalSlides; index++) {
        const slide = serviceSlides[index];
        const container = slide.querySelector('.container');
        if (!container) continue;

        const image = container.querySelector('.services-slider-slide-image');
        const title = container.querySelector('.services-slider-slide-title');
        const description = container.querySelector('.services-slider-slide-description');
        const lists = container.querySelectorAll('.popup-right-content-list');

        // Вычисляем время начала для этого слайда
        const slideStartTime = (index - 1) * 1;

        // СКРЫТИЕ ВСЕХ предыдущих слайдов
        for (let i = 0; i < index; i++) {
            const prevContainer = serviceSlides[i]?.querySelector('.container');
            if (prevContainer) {
                masterTimeline.to(prevContainer, {
                    autoAlpha: 0,
                    ease: 'power2.in',
                    duration: 0.3
                }, slideStartTime);
            }
        }

        // ПОКАЗ текущего слайда
        masterTimeline.to(container, {
            x: 0,
            scale: 1,
            autoAlpha: 1,
            ease: 'power2.out',
            duration: 0.6
        }, slideStartTime);

        // Анимация элементов
        if (image) {
            masterTimeline.to(image, {
                x: 0, scale: 1,
                ease: 'back.out(1.3)', duration: 0.5
            }, slideStartTime + 0.1);
        }

        if (title) {
            masterTimeline.to(title, {
                x: 0, opacity: 1,
                ease: 'power3.out', duration: 0.4
            }, slideStartTime + 0.15);
        }

        if (description) {
            masterTimeline.to(description, {
                x: 0, opacity: 1,
                ease: 'power3.out', duration: 0.4
            }, slideStartTime + 0.2);
        }

        if (lists.length) {
            lists.forEach((list, listIndex) => {
                masterTimeline.to(list, {
                    x: 0, opacity: 1,
                    ease: 'power3.out', duration: 0.4
                }, slideStartTime + 0.25 + (listIndex * 0.05));
            });
        }
    }

    // Вычисляем точки snap
    const snapPoints = [];
    for (let i = 0; i < totalSlides; i++) {
        snapPoints.push(i / (totalSlides - 1));
    }

    // Вычисляем end на основе длительности timeline и желаемой скорости скролла
    const getEndValue = () => {
        const timelineDuration = masterTimeline.duration();
        const scrollPerSecond = window.innerHeight * 1.5;
        const totalScrollDistance = timelineDuration * scrollPerSecond;
        const exitBuffer = window.innerHeight * 0.5;
        return `+=${totalScrollDistance + exitBuffer}`;
    };
    
    // Создаем ScrollTrigger
    const scrollTriggerInstance = ScrollTrigger.create({
        id: 'services-mobile-pin',
        trigger: servicesSlider,
        start: 'top top',
        end: getEndValue,
        pin: true,
        pinSpacing: true,
        scrub: 1.5,
        animation: masterTimeline,
        anticipatePin: 1,
        fastScrollEnd: true,
        preventOverlaps: true,
        invalidateOnRefresh: true,
        refreshPriority: 1,
        snap: {
            snapTo: snapPoints,
            duration: { min: 0.3, max: 0.8 },
            delay: 0.15,
            ease: 'power2.inOut',
            directional: false
        }
    });

    // Возвращаем функцию очистки
    return () => {
        if (scrollTriggerInstance) {
            scrollTriggerInstance.kill();
        }
        
        // Убиваем десктопный pin если он существует
        const desktopPin = ScrollTrigger.getById('services-desktop-pin');
        if (desktopPin) {
            desktopPin.kill();
        }
    };
};

// Обработчик изменения размера окна
let servicesResizeTimer;
let cleanupFunction = null;

window.addEventListener('resize', () => {
    clearTimeout(servicesResizeTimer);
    servicesResizeTimer = setTimeout(() => {
        const isMobile = window.innerWidth < 1024;
        
        if (!isMobile) {
            // Если переключились на десктоп, очищаем все
            if (cleanupFunction) {
                cleanupFunction();
                cleanupFunction = null;
            }
            
            // Убиваем ScrollTriggers по ID
            const mobilePin = ScrollTrigger.getById('services-mobile-pin');
            if (mobilePin) {
                mobilePin.kill();
            }
            
            const desktopPin = ScrollTrigger.getById('services-desktop-pin');
            if (desktopPin) {
                desktopPin.kill();
            }
            
            // Очищаем все inline стили
            const serviceSlides = document.querySelectorAll('.services-slider .services-slider-slide');
            serviceSlides.forEach(slide => {
                const container = slide.querySelector('.container');
                if (container) {
                    gsap.set(container, { clearProps: 'all' });
                }
                
                // Очищаем стили элементов внутри
                const image = container?.querySelector('.services-slider-slide-image');
                const title = container?.querySelector('.services-slider-slide-title');
                const description = container?.querySelector('.services-slider-slide-description');
                const lists = container?.querySelectorAll('.popup-right-content-list');
                
                if (image) gsap.set(image, { clearProps: 'all' });
                if (title) gsap.set(title, { clearProps: 'all' });
                if (description) gsap.set(description, { clearProps: 'all' });
                if (lists) gsap.set(lists, { clearProps: 'all' });
            });
        } else {
            // Реинициализируем для мобильных
            if (cleanupFunction) {
                cleanupFunction();
            }
            cleanupFunction = initServicesAnimation();
            ScrollTrigger.refresh();
        }
    }, 250);
});

// Автоматически инициализируем при загрузке
document.addEventListener('DOMContentLoaded', () => {
    cleanupFunction = initServicesAnimation();
});
